<template>
  <div>
    <!-- 开挂账号管理 -->
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left:5px;">开挂账号管理</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 主体内容 -->
    <div class="container">
      <!-- 顶部搜索区域 -->
      <div class="search">
        <el-form :model="searchObj" label-position="left" inline>
          <el-form-item label="游戏账号：">
            <el-input v-model.trim="searchObj.account" placeholder="请输入游戏账号" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getDataLists">搜索</el-button>
            <el-button type="primary" @click="accountDialog('add')">添加</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 数据表格区域 -->
      <div class="table">
        <el-table border :data="data.tableData" style="width: 100%" height="650">
          <el-table-column prop="game_name" label="游戏名称"></el-table-column>
          <el-table-column prop="account" label="游戏账号"></el-table-column>
          <el-table-column prop="device_id" label="设备ID"></el-table-column>
          <el-table-column prop="last_login_ip" label="最后一次登录IP"></el-table-column>
          <el-table-column prop="created_at" label="创建时间"></el-table-column>
          <el-table-column label="操作" >
            <template slot-scope="scope">
              <el-link :underline="false" type="primary" @click="accountDialog('edit', scope.row)">编辑</el-link>
              <el-link :underline="false" type="primary" @click="deleteHookAccount(scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          v-show="data.total>0"
          :total="data.total"
          :page.sync="searchObj.page"
          :limit.sync="searchObj.limit"
          @pagination="getDataLists"
        />
      </div>
    </div>

    <!-- 添加/编辑账号的弹窗 -->
    <el-dialog
      :title="accountDialogObj.dialogTitle"
      :visible.sync="accountDialogObj.accountDialogVisible"
      width="500px"
      @close="accountDialogClose"
      :close-on-click-modal="false">
      <div class="accountForm">
        <el-form :model="accountDialogObj.formItemObj" :rules="formItemrules" ref="ruleForm" label-position="right" label-width="130px" class="demo-ruleForm" v-loading="accountDialogObj.loading">
          <el-form-item label="游戏账号：" prop="account">
            <el-input :disabled="accountDialogObj.dialogTitle === '编辑' ? true: false" placeholder="请输入游戏账号" v-model="accountDialogObj.formItemObj.account"></el-input>
          </el-form-item>
          <el-form-item label="设备ID：">
            <el-input placeholder="请输入设备ID" v-model="accountDialogObj.formItemObj.device_id"></el-input>
          </el-form-item>
          <el-form-item label="最后一次登录IP：">
            <el-input placeholder="请输入最后一次登录IP" v-model="accountDialogObj.formItemObj.last_login_ip"></el-input>
          </el-form-item>
          <el-form-item label="游戏名称：" prop="game_id">
            <el-cascader
              style="width: 320px"
              v-model="accountDialogObj.formItemObj.game_id"
              :options="gameLists"
              :props="cascaderProps"
              collapse-tags
              filterable
              :show-all-levels="false"
            ></el-cascader>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="accountDialogClose">取 消</el-button>
        <el-button type="primary" @click="sureChangeHookAccount">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/pagination/index";
import {
  getTableLists,
  addNewAccount,
  getAccountDetail,
  editAccount,
  deleteAccount,
  getGamsLists
} from '@/api/work_openHook_account'

export default {
  name: 'work_openHook_account',
  components: { Pagination },
  data() {
    return {
      searchObj: {
        account: '', // 游戏账号
        page: 1,
        limit: 10
      },
      data: {
        tableData: [],
        total: 0,
      },
      // 弹框相关属性
      accountDialogObj: {
        accountDialogVisible: false,
        dialogTitle: '添加',
        loading: false,
        id: '', // 编辑时候需要id
        formItemObj: {
          account: '', // 游戏账号
          device_id: '', // 设备ID
          last_login_ip: '', // 最后一次登录IP
          game_id: [] // 游戏
        },
      },
      formItemrules: {
        account: [
          { required: true, message: '请输入游戏账号', trigger: 'blur' }
        ],
        game_id: [
          { required: true, message: '请选择主游戏', trigger: 'change' }
        ]
      },
      // 运用后台游戏列表
      gameLists: [],
      cascaderProps: {
        expandTrigger: 'click',
        multiple: true,
        value: 'id',
        label: 'text',
        emitPath: false
      }
    }
  },
  created() {
    this.getDataLists()
  },
  methods: {
    // 获取运营后台游戏列表
    getGamsLists() {
      this.accountDialogObj.loading = true
      getGamsLists().then(({ data: res }) => {
        this.gameLists = res.data
        if (this.accountDialogObj.dialogTitle === '添加') {
          this.$refs.ruleForm.resetFields();
        }
        this.accountDialogObj.loading = false
      }).catch(() => {})
    },

    // 获取表格数据列表
    getDataLists() {
      const params = {
        account: this.searchObj.account,
        limit: this.searchObj.limit,
        page: this.searchObj.page
      }

      getTableLists(params).then(({ data: res }) => {
        this.data.tableData = res.data.data
        this.data.total = res.data.total
      }).catch(() => {}) 
    },

    // 添加/编辑弹框
    accountDialog(type, row) {
      this.accountDialogObj.dialogTitle = type === 'add' ? '添加' : '编辑'
      this.accountDialogObj.accountDialogVisible = true
      if (type === 'edit') {
        this.getAccountDetailInfo(row)
      }
      this.getGamsLists()
    },

    // 获取账号详情，编辑的时候回显数据
    getAccountDetailInfo(row) {
      getAccountDetail({ id: row.id }).then(({ data: res }) => {
        if (res.code == 200) {
          this.accountDialogObj.id = res.data.id
          this.accountDialogObj.formItemObj = res.data
        }
      }).catch(() => {})
    },

    // 弹窗的确认按钮
    sureChangeHookAccount() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return

        // 校验通过  添加/编辑的逻辑
        if (this.accountDialogObj.dialogTitle === '添加') {
          // 添加游戏账号
          this.addHookAccount()
        } else {
          // 编辑
          this.editAccount()
        }

      });
    },

    // 添加开挂账号的事件
    addHookAccount() {
      addNewAccount(this.accountDialogObj.formItemObj).then(({ data: res }) => {
        if (res.code === 200) {
          this.$message.success('添加成功')
          this.getDataLists()
          this.accountDialogClose()
        } else {
          this.$message.error(res.message);
        }
      }).catch(() => {})
    },

    // 编辑账号
    editAccount() {
      editAccount({ id: this.accountDialogObj.id, ...this.accountDialogObj.formItemObj }).then(({ data: res }) => {
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.getDataLists()
          this.accountDialogClose()
          this.accountDialogObj.id = ''
        } else {
          this.$message.error(res.message);
        }
      })
    },



    // 弹窗关闭
    accountDialogClose() {
      this.$refs.ruleForm.resetFields();
      for (let key in this.accountDialogObj.formItemObj) {
        this.accountDialogObj.formItemObj[key] = ''
      }
      this.accountDialogObj.accountDialogVisible = false
    },

    // 删除游戏账号
    deleteHookAccount(row) {
      this.$confirm('此操作将永久删除该游戏账号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAccount({ id: row.id }).then(({ data: res }) => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getDataLists()
          } else {
            this.$message.error(res.message);
          }
        })
      }).catch(() => {        
      });
    }
  },
}
</script>

<style lang="less">
  .search {
    .el-input {
      width: 180px;
    }
    .el-button {
      margin: 0;
      margin-right: 10px;
    }
  }
  .el-link {
    margin-right: 10px;
  }
</style>